import type {JobNodes} from "#job-nodes/job-nodes"
import {makeJobTaskDescriptor} from "#job-nodes/job-nodes"

//TODO: unify this with backend/tasks/material-ai/validation.ts

export type ImageToPbrMapsInput = {
    inputImage: JobNodes.DataObjectReference
    inputImageRange?: number
    dpi?: number
    filterRadius?: number // pixels
    generateDisplacement?: boolean
    tags?: number[]
}

export type ImageToPbrMapsOutput = {
    diffuse: JobNodes.DataObjectReference
    normal: JobNodes.DataObjectReference
    roughness: JobNodes.DataObjectReference
    metalness: JobNodes.DataObjectReference
    anisotropy: JobNodes.DataObjectReference
    specularStrength: JobNodes.DataObjectReference
    displacement?: JobNodes.DataObjectReference
}

export enum MaterialAiTag {
    MaterialType_Textile = 0,
    MaterialType_Vinyl = 1,
    MaterialType_Leather = 2,
    MaterialType_WallCovering = 3,
    MaterialType_Other = 4,
    TextileType_Woven = 5,
    TextileType_Knitted = 6,
    TextileType_FeltNonwoven = 7,
    TextileType_VelvetVelour = 8,
    TextileType_CutPile = 9,
    TextileType_LoopPile = 10,
    TextileType_Mixed = 11,
    TextileType_Other = 12,
    SurfaceTexture_None = 13,
    SurfaceTexture_Light = 14,
    SurfaceTexture_Moderate = 15,
    SurfaceTexture_Heavy = 16,
    SurfaceTexture_MixedPatterned = 17,
    Fuzz_None = 18,
    Fuzz_Light = 19,
    Fuzz_Moderate = 20,
    Fuzz_Heavy = 21,
    Reflectivity_Matte = 22,
    Reflectivity_Intermediate = 23,
    Reflectivity_Glossy = 24,
    Reflectivity_MixedPatterned = 25,
    PatternMethod_WovenEmbroidered = 26,
    PatternMethod_PrintedDyedColor = 27,
    PatternMethod_EmbossedTextureOnly = 28,
    PatternMethod_PrintedColorEmbossedTexture = 29,
    OtherFeatures_Sheen = 30,
    OtherFeatures_SilkyAnisotropic = 31,
    OtherFeatures_Velvety = 32,
    OtherFeatures_Sparkly = 33,
    OtherFeatures_GlossyHighlights = 34,
    OtherFeatures_Depth = 35,
    OtherFeatures_Coated = 36,
    OtherFeatures_Iridescent = 37,
    OtherFeatures_Complex3DStructure = 38,
    MaterialType_WoodNatural = 39,
    MaterialType_WoodPrinted = 40,
    MaterialType_Mulch = 41,
    MaterialType_Rocks = 42,
    MaterialType_Rattan = 43,
}

export const imageToPbrMaps = makeJobTaskDescriptor<ImageToPbrMapsInput, ImageToPbrMapsOutput>("MaterialAi.imageToPbrMaps", 1)
